import type { TOC } from '@ember/component/template-only';
import { and, not } from 'ember-truth-helpers';
import { local } from 'embroider-css-modules';
import hasFeatureToggle from 'lumen/helpers/has-feature-toggle';
import isDrawerExpanded from 'lumen/helpers/is-drawer-expanded';
import { FEATURE_TOGGLES } from 'lumen/utils/constants/feature-toggle-constants';
import { DRAWER_IDS } from 'lumen/utils/constants/general-constants';

import styles from './header.module.css';

interface GeneralPageHeaderSignature {
  Args: {
    isSmall?: boolean;
  };
  Blocks: {
    default: [];
  };
  Element: HTMLElement;
}

/* The `smart-insights-react` flag's drawer is a real flex sibling of
   #content-container (see hotel.module.css's `.smart-insights-row`), which
   already shrinks this page's content -- including this header, itself
   inside #content-container -- to make room. Applying this class too would
   shrink it a second time. Only the legacy Ember drawer (a fixed overlay
   with no layout effect of its own) needs this class to make room for
   itself. */
const GeneralPageHeader: TOC<GeneralPageHeaderSignature> = <template>
  <header
    class={{local
      styles
      "header"
      (if @isSmall "header--small")
      (if
        (and
          (isDrawerExpanded DRAWER_IDS.SMART_INSIGHTS_DRAWER)
          (not (hasFeatureToggle FEATURE_TOGGLES.SMART_INSIGHTS_REACT))
        )
        "smart-insights-open"
      )
    }}
    ...attributes
  >
    {{yield}}
  </header>
</template>;

export default GeneralPageHeader;
